var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP4RBusinessWalletManage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7,11 H35 C38,11 40,13 40,16 V36 H10 C8,36 7,35 7,33 Z",
    fill: "#7C1CFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27,20 H43 V31 H27 C24,31 22,29 22,25.5 C22,22 24,20 27,20 Z",
    fill: "#00D4FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29,23 A3,3 0,1 0,29,29 A3,3 0,1 0,29,23",
    fill: "#FFFFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11,8 H31 V12 H11 Z",
    fill: "#FFD000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP4RBusinessWalletManage);
export default __webpack_public_path__ + "static/media/p4r_business_wallet_manage.4260baa6019cc3055613c3cf9ce05829.svg";
export { ForwardRef as ReactComponent };